<template>
  <div>
    <Header>

        <div class="buttons-right"  v-if="article">
            <span v-show="!allChangesSaved(article)" class="change-notice change-notice--unsaved"><span v-t="'Unsaved Changes'"></span> <i class="material-icons">error_outline</i></span>
            <span v-show="allChangesSaved(article)" class="change-notice"><span v-t="'All Changes Saved'"></span></span>

            <a class="button--delete" @click="deleteArticle" v-t="'Delete Article?'"></a>
            <a class="button--delete" onclick="window.open(this.href, 'jp-dashboard'); return false"  :href="article.view_url" v-if="article.item_type=='blog'" target="_blank" v-t="'View Article'"></a>
            <save-button name="Article" :status="saving" @save="save()"></save-button>
        </div>

    </Header>

    <div class="page">
        <div v-if="article&&!article.restricted&&article.blocks.length>0&&is_new" class="alert alert--social">
            <i class="material-icons">thumb_up</i>
            <p v-t="'Nice one, article added! Let people know you\'ve updated your portfolio.'"></p>
            <p>Share it on
                <a target="_blank" rel="noopener" :href="twitter_share_link">Twitter</a>, <a target="_blank" rel="noopener" :href="facebook_share_link">Facebook</a> or <a target="_blank" rel="noopener" :href="linkedin_share_link">Linkedin</a>
            </p>
        </div>

        <div class="alert" v-if="article&&article.blocks.length!=0&&article.restricted">
            <i class="material-icons">warning</i>
            <p>
                <span v-t="'Article not currently displaying due to the limits on the free plan.'"></span> <router-link :to="{name: 'account'}"> <span v-t="'Upgrade to remove limits'"></span> &rarr;</router-link>
            </p>
        </div>
        <div class="alert" v-if="article&&article.blocks.length==0">
            <i class="material-icons">warning</i>
            <p v-t="'Article not attached to any blocks, so not being displayed. Add it to a block with the \'blocks\' field.'"></p>
        </div>

        <div class="left-col">
            <div class="block" v-if="!article">
                <div class="loading-gif" >
                    <img :src="VUE_APP_STATIC_URL + 'img/loading.gif'">
                </div>
            </div>

            <div class="block" v-if="article">
                <field :errors="errors" label="Article Title" name="title">
                    <input type="text" v-model="article.title">
                </field>
                <field :errors="errors" label="Article URL" v-if="article.item_type!='blog'&&!article.file&&article.item_type!='image'" name="url">
                    <input type="text" v-model="article.url">
                </field>
                <div class="field field--file field-width" v-if="article.item_type=='file'">
                    <label v-t="'Article PDF'"></label>

                    <file-picker @remove="article.file=null" :model="article.file" title="Upload PDF" @changed="article.file=$event"></file-picker>

                </div>
                <field :errors="errors" label="Text Excerpt" name="extract">
                    <AutosizeTextarea v-model="article.extract" placeholder="Short Text Excerpt About Article"></AutosizeTextarea>

                </field>

            </div>
            <div class="block block--full" v-if="article&&article.item_type=='blog'">
                <h3 class="block__heading" v-t="'Article Body'"></h3>
                <Redactor v-model="article.content" :config="{buttons: ['html', 'format', 'bold', 'italic', 'underline', 'deleted', 'lists', 'image', 'file', 'link', 'horizontalrule'], fileUpload: 'https://api.journoportfolio.com/redactor-upload/', fileManagerJson: 'https://api.journoportfolio.com/redactor-files/', imageUpload: 'https://api.journoportfolio.com/redactor-upload/', imageManagerJson: 'https://api.journoportfolio.com/redactor-images/', linkNewTab: true, linkTitle: true, imageResizable: true, imagePosition: true, plugins: ['table', 'video', 'fontsize', 'alignment', 'counter', 'fontcolor', 'imagemanager', 'filemanager']}" />

            </div>
            <div class="block block--full" v-if="article&&article.item_type!='blog'">
                <h3 class="block__heading" v-t="'Description on Open (optional)'"></h3>
                <Redactor v-model="article.description" :config="{buttons: ['html', 'format', 'bold', 'italic', 'underline', 'deleted', 'lists', 'image', 'file', 'link', 'horizontalrule'], fileUpload: 'https://api.journoportfolio.com/redactor-upload/', fileManagerJson: 'https://api.journoportfolio.com/redactor-files/', imageUpload: 'https://api.journoportfolio.com/redactor-upload/', imageManagerJson: 'https://api.journoportfolio.com/redactor-images/', linkNewTab: true, linkTitle: true, imageResizable: true, imagePosition: true, plugins: ['table', 'video', 'fontsize', 'alignment', 'counter', 'fontcolor', 'imagemanager', 'filemanager']}" />

            </div>


            <div class="block block--full" v-if="article&&article.comments_enabled">
                <h3 class="block__heading" v-t="'Article Comments'"></h3>

                <table class="editor-table">
                    <thead>
                        <tr>
                            <th width="150px" v-t="'Details'"></th>
                            <th v-t="'Content'"></th>
                            <th width="150px" v-t="'Status'"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-bind:key="comment.id" v-for="comment in comments">
                            <td>{{comment.name}}
                                <span class="small">{{comment.email}}</span>
                                <span class="small">{{comment.datetime | date }}</span>
                            </td>
                            <td><p v-html="comment.content"></p>
                            </td>
                            <td>
                                <select v-model="comment.status" v-change="updateCommentStatus(comment)" class="font-picker font-picker-heading">
                                    <option value="published" v-t="'Published'"></option>
                                    <option value="hidden" v-t="'Hidden'"></option>
                                    <option value="spam" v-t="'Spam'"></option>
                                </select>
                            </td>
                        </tr>
                        <tr v-if="comments.length===0">
                            <td colspan="3" v-t="'No comments yet'"></td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <td colspan="100%" >
                            {{comments.length}} <span v-t="'comments'"></span>
                        </td>
                    </tfoot>
                </table>
            </div>
        </div>
        <div class="right-col">

            <div class="block" v-if="!article">
                <div class="loading-gif" >
                    <img :src="VUE_APP_STATIC_URL + 'img/loading.gif'">
                </div>
            </div>

            <div class="block" v-if="article">
                <field :errors="errors" label="Published Date" name="published_date" style="display:block;clear:both;min-height:60px;">
                    <datepicker v-model="article.published_date"></datepicker>
                </field>
                <field :errors="errors" label="Publication Name" name="publication_name">
                    <publication-field :article="article" />

                </field>
                <div class="field">
                    <label v-t="'Blocks to display on'"></label>
                    <block-field :article="article" :blocks="blocks" />

                    <div class="hr"></div>
                    <div class="field field-width" style="z-index: 999">
                        <label v-t="'Tags'"></label>

                        <tags-field :article="article" :tags="tags" />

                    </div>
                    <div class="field field-width">
                        <label v-t="'Article Image'"></label>
                        <div class="field field--file">

                            <image-picker @remove="article.image=null" :model="article" @close="article.image=$event"></image-picker>

                        </div>
                    </div>
                    <div class="field field--width" v-if="article.item_type=='blog'">
                        <field :errors="errors" label="SEO Description" name="seo_description">
                            <AutosizeTextarea v-model="article.seo_description"></AutosizeTextarea>
                            <span class="help_text">An optional description used by search engines. Should describe the article.</span>
                        </field>
                    </div>
                </div>
                <div class="hr"></div>

                <field :errors="errors" class="field field-switch" v-if="article.item_type=='blog'">
                    <label class="switch">
                        <input v-model="article.comments_enabled" type="checkbox">
                        <div class="slider round"></div>
                    </label>
                    <span class="label" v-t="'Enable Comments?'"></span>
                </field>

                <field :errors="errors" class="field field-switch">
                    <label class="switch">
                        <input v-model="article.published" type="checkbox">
                        <div class="slider round"></div>
                    </label>
                    <span class="label" v-t="'Display on portfolio?'"></span>
                </field>

                <field :errors="errors" class="field field-switch">
                    <label class="switch">
                        <input v-model="article.hide_date" type="checkbox">
                        <div class="slider round"></div>
                    </label>
                    <span class="label" v-t="'Hide Date?'"></span>
                </field>
            </div>
        </div>
    </div>

    <modal-article-delete v-if="article" :article="article" :open="modalDeleteOpen" @close="modalDeleteOpen=false"></modal-article-delete>
    <modal-unsaved-changes :open="modalUnsavedChangesOpen" @leave="leavePage" @close="modalUnsavedChangesOpen=false"></modal-unsaved-changes>
</div>
</template>

<script>
    import Header from '@/components/Header.vue'
    import Field from '@/components/Field.vue'
    import BlockField from '@/components/fields/BlockField.vue'
    import PublicationField from '@/components/fields/PublicationField.vue'
    import TagsField from '@/components/fields/TagsField.vue'
    import AutosizeTextarea from '@/components/AutosizeTextarea.vue'
    import Datepicker from '@/components/Datepicker.vue'
    import SaveButton from '@/components/SaveButton.vue'
    import ImagePicker from  '@/components/ImagePicker.vue'
    import FilePicker from  '@/components/FilePicker.vue'
    import Redactor from  '@/components/Redactor.vue'
    import ModalArticleDelete from '@/components/modals/ModalArticleDelete.vue'
    import ModalUnsavedChanges from '@/components/modals/ModalUnsavedChanges.vue'

    export default {
      name: 'articles_list',
      components: {
        Header,
        Field,
        TagsField,
        BlockField,
        PublicationField,
        AutosizeTextarea,
        Datepicker,
        SaveButton,
        ImagePicker,
        FilePicker,
        ModalArticleDelete,
        ModalUnsavedChanges,
        Redactor
    },

    data () {
        return {
            VUE_APP_STATIC_URL: process.env.VUE_APP_STATIC_URL,
            saving: false,
            errors: {},
            modalDeleteOpen: false,
            modalUnsavedChangesOpen: false,
            next: null,
            comments: [],
            article: null,
            tags: [],
            clickedElement: false,
            blocks: [],
        }
    },
    watch: {
      '$route.params.id' (toID, fromID) {
        this.loadData(toID)
      }
    },
    computed: {
      is_new() {
        if (window.location.search.indexOf('new') !== -1) {
          return true
        }
        return false
      },
      user() {
        return this.$store.getters['auth/user']
      },
      portfolio () {
        return this.$store.getters['portfolio/portfolio']
      },
      facebook_share_link() {
        if (this.portfolio && this.portfolio.get_absolute_url !== '') {
          return (
            'https://www.facebook.com/dialog/feed?app_id=251448785017470&link=' +
            encodeURIComponent(this.portfolio.get_absolute_url) +
            '&name=' +
            encodeURIComponent(this.portfolio.full_name + "'s Portfolio") +
            '&description=' +
            encodeURIComponent('Built with Journo Portfolio') +
            '&redirect_uri=https%3A%2F%2Fwww.journoportfolio.com/dashboard/'
          )
        } else {
          return ''
        }
      },
      twitter_share_link() {
        if (this.portfolio && this.portfolio.get_absolute_url !== '') {
          var url =
            "I've just updated my @journoportfolio site, check it out here: " +
            this.portfolio.get_absolute_url
          return 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(url)
        } else {
          return ''
        }
      },
      linkedin_share_link() {
        if (this.portfolio && this.portfolio.get_absolute_url !== '') {
          return (
            'https://www.linkedin.com/cws/share?url=' + encodeURIComponent(this.portfolio.get_absolute_url)
          )
        } else {
          return ''
        }
      },
    },
    methods: {
        leavePage () {
            this.modalUnsavedChangesOpen = false;
            this.next()
        },
        save () {
            this.saving = true
            this.$http.put('/articles/'+this.$route.params.id+'/', this.article).then(data => {
                this.saving = false
                this.article = data.data
                this.past_article = Object.assign({}, data.data)
            }).catch(errors => {
              this.saving = false
                if(errors && errors.response && errors.response.data){
                    this.errors = errors.response.data
                }
            })
        },
        allChangesSaved (article) {
            if(!article){
                return false;
            }
            if (JSON.stringify(this.past_article) === JSON.stringify(this.article)){
                return true
            }
            return false;
        },
        deleteArticle() {
            this.modalDeleteOpen = true
        },
        updateCommentStatus (comment){
            this.$http.put('/articles/'+this.$route.params.id+'/comments/'+comment.id+'/', {status: comment.status})
        },
        loadData(ID) {
          this.$http.all([
              this.$http.get('/articles/'+ID+'/'),
              this.$http.get('/tags/'),
              this.$http.get('/blocks/')
              ])
          .then(this.$http.spread((article, tags, blocks) => {
              this.article = article.data
              this.past_article = Object.assign({}, article.data)
              this.tags = tags.data
              this.blocks = blocks.data

              if(this.article.comments_enabled){
                  this.$http.get('/articles/'+ID+'/comments/').then(data => {
                      this.comments = data.data;
                  })
              }
          }))
        }
    },
    mounted () {
      this.loadData(this.$route.params.id);
    },
    beforeRouteLeave (to, from, next) {
      if(!this.allChangesSaved(this.article)){
        this.modalUnsavedChangesOpen = true
        this.next = next
      }else{
        next()
      }
    }
}
</script>
